import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.wholeHouse.additionalParameter.sortFields,
	columnFields: constants.wholeHouse.additionalParameter.columnFields,
	standardFilterFields: constants.wholeHouse.additionalParameter.osStandardFilterFields,
	dateFilterFields: constants.wholeHouse.additionalParameter.osDateFilterFields,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: [] as const,
});
